module.exports = __webpack_public_path__ + "static/media/moreHorizontal.5cde19cf.svg";